(function() {
  'use strict';

  angular.module('app.maps')
    .service('Loader', ['$rootScope', function LoaderFactory($rootScope) {
      let loader = this;

      loader.state = true;

      loader.enable = function() {
        if (this.state !== true) {
          this.state = true;
          $rootScope.$broadcast('loader:toggled');
        }
      };

      loader.disable = function() {
        if (this.state !== false) {
          this.state = false;
          $rootScope.$broadcast('loader:toggled');
        }
      };
    }]);
}());
